export const OpsgenieLogoInverse = () => (
  <svg
    width="231"
    height="48"
    viewBox="0 0 231 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.694 25.5421C20.8441 25.5421 25.019 21.3671 25.019 16.2171C25.019 11.067 20.8441 6.89209 15.694 6.89209C10.5439 6.89209 6.369 11.067 6.369 16.2171C6.369 21.3671 10.5439 25.5421 15.694 25.5421Z"
      fill="url(#paint0_linear_818_513)"
    />
    <path
      d="M14.899 44.037C8.809 40.152 3.744 34.857 0.132001 28.601C-0.148999 28.097 0.0320014 27.46 0.537001 27.179C0.553001 27.17 0.570001 27.161 0.587001 27.153L7.649 23.687C8.143 23.446 8.739 23.629 9.013 24.105C12.583 30.089 17.863 34.868 24.172 37.827C21.845 40.171 19.268 42.254 16.488 44.037C16.002 44.341 15.385 44.341 14.899 44.037Z"
      fill="url(#paint1_linear_818_513)"
    />
    <path
      d="M16.488 44.037C22.579 40.153 27.644 34.858 31.255 28.601C31.537 28.097 31.357 27.46 30.853 27.178C30.837 27.169 30.821 27.161 30.805 27.153L23.738 23.687C23.244 23.446 22.648 23.629 22.374 24.105C18.804 30.09 13.525 34.869 7.215 37.827C9.54 40.173 12.117 42.256 14.899 44.037C15.385 44.341 16.002 44.341 16.488 44.037Z"
      fill="white"
    />
    <path
      d="M44.033 23.5709C44.033 14.4619 49.277 8.06689 58.617 8.06689C67.91 8.06689 73.154 14.4619 73.154 23.5709C73.154 32.7719 67.91 39.2129 58.617 39.2129C49.277 39.2129 44.033 32.7729 44.033 23.5709ZM48.174 23.5709C48.174 29.9659 51.164 35.2559 58.617 35.2559C66.023 35.2559 69.013 29.9659 69.013 23.5709C69.013 17.3139 66.023 12.0229 58.617 12.0229C51.164 12.0229 48.174 17.3139 48.174 23.5709Z"
      fill="white"
    />
    <path
      d="M82.398 34.704V47.724H78.441V15.75H82.398V19.891C83.869 16.855 86.63 15.29 90.171 15.29C96.29 15.29 99.372 20.488 99.372 27.251C99.372 33.738 96.151 39.213 89.712 39.213C86.353 39.213 83.776 37.694 82.398 34.704ZM89.113 18.971C85.572 18.971 82.398 21.225 82.398 26.331V28.172C82.398 33.278 85.294 35.532 88.654 35.532C93.117 35.532 95.416 32.588 95.416 27.251C95.416 21.73 93.209 18.971 89.113 18.971Z"
      fill="white"
    />
    <path
      d="M111.193 39.213C107.742 39.213 104.935 38.431 103.187 37.511V33.324C105.166 34.474 108.478 35.578 111.376 35.578C114.413 35.578 115.978 34.336 115.978 32.542C115.978 30.794 114.642 29.781 110.273 28.724C105.166 27.482 103.003 25.503 103.003 21.731C103.003 17.729 106.085 15.291 111.331 15.291C114.321 15.291 117.034 16.027 118.737 16.947V21.042C115.977 19.661 113.721 18.926 111.284 18.926C108.386 18.926 106.821 19.938 106.821 21.732C106.821 23.342 107.926 24.355 112.159 25.367C117.264 26.609 119.841 28.495 119.841 32.498C119.841 36.316 117.357 39.215 111.193 39.215V39.213Z"
      fill="white"
    />
    <path
      d="M140.818 34.612C139.345 37.648 136.586 39.213 133.043 39.213C126.971 39.213 123.934 34.014 123.934 27.251C123.934 20.765 127.108 15.29 133.504 15.29C136.861 15.29 139.438 16.809 140.818 19.799V15.75H144.681V36.683C144.681 43.446 141.507 48 133.273 48C129.408 48 127.293 47.494 125.084 46.758V42.894C127.615 43.722 130.236 44.274 133.09 44.274C138.84 44.274 140.819 41.192 140.819 36.913V34.613L140.818 34.612ZM134.101 35.532C137.642 35.532 140.818 33.278 140.818 28.172V26.331C140.818 21.225 137.92 18.971 134.56 18.971C130.097 18.971 127.798 21.915 127.798 27.251C127.798 32.772 130.005 35.532 134.101 35.532Z"
      fill="white"
    />
    <path
      d="M161.654 39.213C153.052 39.213 149.279 34.244 149.279 27.205C149.279 20.259 153.144 15.29 160.136 15.29C167.22 15.29 170.074 20.213 170.074 27.205V29H153.281C153.834 32.91 156.365 35.44 161.793 35.44C164.461 35.44 166.715 34.934 168.785 34.198V37.833C166.9 38.845 164.002 39.213 161.654 39.213ZM153.236 25.595H166.072C165.842 21.317 163.91 18.879 159.953 18.879C155.765 18.879 153.65 21.593 153.236 25.595Z"
      fill="white"
    />
    <path
      d="M194.316 38.753H190.359V24.859C190.359 20.718 188.703 18.879 184.929 18.879C181.249 18.879 178.72 21.317 178.72 25.963V38.753H174.763V15.75H178.72V19.522C180.191 16.808 182.906 15.29 185.988 15.29C191.279 15.29 194.316 18.925 194.316 25.273V38.752V38.753Z"
      fill="white"
    />
    <path
      d="M201.857 6.91699C203.468 6.91699 204.617 7.92899 204.617 9.67799C204.617 11.427 203.469 12.438 201.857 12.438C200.245 12.438 199.097 11.426 199.097 9.67799C199.097 7.92999 200.247 6.91699 201.857 6.91699ZM199.834 15.75H203.791V38.753H199.834V15.75Z"
      fill="white"
    />
    <path
      d="M221.684 39.213C213.082 39.213 209.309 34.244 209.309 27.205C209.309 20.259 213.174 15.29 220.166 15.29C227.25 15.29 230.104 20.213 230.104 27.205V29H213.311C213.864 32.91 216.395 35.44 221.823 35.44C224.491 35.44 226.745 34.934 228.815 34.198V37.833C226.93 38.845 224.032 39.213 221.684 39.213ZM213.266 25.595H226.102C225.872 21.317 223.94 18.879 219.983 18.879C215.795 18.879 213.68 21.593 213.266 25.595Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_513"
        x1="15.694"
        y1="9.99209"
        x2="15.694"
        y2="29.1391"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.15" stopColor="white" stopOpacity="0.98" />
        <stop offset="0.31" stopColor="white" stopOpacity="0.93" />
        <stop offset="0.48" stopColor="white" stopOpacity="0.84" />
        <stop offset="0.66" stopColor="white" stopOpacity="0.72" />
        <stop offset="0.84" stopColor="white" stopOpacity="0.56" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_818_513"
        x1="9.948"
        y1="28.603"
        x2="16.362"
        y2="42.027"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.85" stopColor="white" stopOpacity="0.35" />
      </linearGradient>
    </defs>
  </svg>
);
